/**
 * Transform'Action — comportements de la surcouche de marque.
 * Meme logique que theme.js du site Shopify : un seul message visible,
 * rotation toutes les 4,2 s, desactivee si l'utilisateur reduit les animations.
 */
(function () {
  'use strict';

  var bar = document.querySelector('.ta-announcement');

  // Le bandeau passe sur deux lignes sur petit ecran. Le bouton hamburger est
  // en position fixed : on publie la hauteur reelle du bandeau pour qu'il se
  // place toujours juste en dessous, quel que soit le message affiche.
  if (bar) {
    var publishHeight = function () {
      document.documentElement.style.setProperty(
        '--ta-announcement-h',
        Math.ceil(bar.getBoundingClientRect().height) + 'px'
      );
    };
    publishHeight();
    window.addEventListener('resize', publishHeight);
    if ('ResizeObserver' in window) new ResizeObserver(publishHeight).observe(bar);
  }

  var messages = Array.prototype.slice.call(document.querySelectorAll('[data-ta-announcement]'));
  if (messages.length < 2) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var index = 0;
  window.setInterval(function () {
    messages[index].classList.remove('is-active');
    index = (index + 1) % messages.length;
    messages[index].classList.add('is-active');
  }, 4200);
})();

/**
 * Carrousel avant / apres — meme logique que setupCarousel() du site Shopify :
 * on fait defiler la piste d'une carte a la fois, et on boucle aux extremites.
 */
(function () {
  'use strict';

  var track = document.querySelector('[data-ba-track]');
  var prev = document.querySelector('[data-ba-prev]');
  var next = document.querySelector('[data-ba-next]');
  if (!track || !prev || !next) return;

  var GAP = 22; // doit rester aligne sur le `gap` de .ba-viewport

  var step = function () {
    var card = track.firstElementChild;
    return card ? card.getBoundingClientRect().width + GAP : track.clientWidth;
  };

  var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  next.addEventListener('click', function () {
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: behavior });
  });

  prev.addEventListener('click', function () {
    var atStart = track.scrollLeft <= 8;
    track.scrollTo({ left: atStart ? track.scrollWidth : track.scrollLeft - step(), behavior: behavior });
  });
})();

/**
 * Carrousel d'apercu de l'outil : fleches, pastilles de position, et
 * ouverture d'une vue agrandie au clic sur une carte.
 */
(function () {
  'use strict';

  var track = document.querySelector('[data-preview-track]');
  var prev = document.querySelector('[data-preview-prev]');
  var next = document.querySelector('[data-preview-next]');
  if (!track || !prev || !next) return;

  var GAP = 22; // doit rester aligne sur le `gap` de .ta-preview__viewport
  var dots = Array.prototype.slice.call(document.querySelectorAll('[data-preview-dot]'));
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduceMotion ? 'auto' : 'smooth';

  var step = function () {
    var card = track.firstElementChild;
    return card ? card.getBoundingClientRect().width + GAP : track.clientWidth;
  };

  var syncDots = function () {
    if (!dots.length) return;
    var index = Math.round(track.scrollLeft / Math.max(1, step()));
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  };

  next.addEventListener('click', function () {
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: behavior });
  });

  prev.addEventListener('click', function () {
    var atStart = track.scrollLeft <= 8;
    track.scrollTo({ left: atStart ? track.scrollWidth : track.scrollLeft - step(), behavior: behavior });
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      track.scrollTo({ left: Number(dot.getAttribute('data-preview-dot')) * step(), behavior: behavior });
    });
  });

  track.addEventListener('scroll', syncDots, { passive: true });
  window.addEventListener('resize', syncDots);
  syncDots();

  // --- Vue agrandie ---
  var dialog = document.querySelector('[data-preview-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var image = dialog.querySelector('[data-preview-image]');
  var caption = dialog.querySelector('[data-preview-caption]');
  var close = dialog.querySelector('[data-preview-close]');

  track.querySelectorAll('[data-preview-src]').forEach(function (card) {
    card.addEventListener('click', function () {
      var titre = card.getAttribute('data-preview-title') || '';
      image.src = card.getAttribute('data-preview-src');
      image.alt = titre;
      caption.textContent = titre;
      dialog.showModal();
    });
  });

  if (close) close.addEventListener('click', function () { dialog.close(); });

  // Clic sur le fond : on ferme.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
})();

/**
 * « La ou ca coince » : selecteur d'onglets.
 * Les panneaux ne sont masques QU'ICI, en JavaScript : si le script ne
 * s'execute pas, les six reponses restent visibles empilees.
 */
(function () {
  'use strict';

  var racine = document.querySelector('[data-coince]');
  if (!racine) return;

  var onglets = Array.prototype.slice.call(racine.querySelectorAll('[role="tab"]'));
  var panneaux = Array.prototype.slice.call(racine.querySelectorAll('[role="tabpanel"]'));
  if (onglets.length !== panneaux.length || !onglets.length) return;

  var activer = function (index, donnerFocus) {
    onglets.forEach(function (onglet, i) {
      var actif = i === index;
      onglet.setAttribute('aria-selected', String(actif));
      onglet.tabIndex = actif ? 0 : -1;
      panneaux[i].hidden = !actif;
    });
    if (donnerFocus) onglets[index].focus();
  };

  onglets.forEach(function (onglet, i) {
    onglet.addEventListener('click', function () {
      activer(i, false);
    });

    onglet.addEventListener('keydown', function (event) {
      var suivant = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') suivant = (i + 1) % onglets.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') suivant = (i - 1 + onglets.length) % onglets.length;
      else if (event.key === 'Home') suivant = 0;
      else if (event.key === 'End') suivant = onglets.length - 1;
      if (suivant === null) return;
      event.preventDefault();
      activer(suivant, true);
    });
  });

  activer(0, false);
})();

/**
 * Mini-diagnostic.
 * Toutes les donnees ci-dessous sont reprises telles quelles de l'ebook
 * (NIVEAUX, OBJECTIFS et FEATURED_EXERCISES dans vercel-transformaction) :
 * volumes, temps de repos, plages de repetitions, macros et noms d'exercices.
 * Rien n'est invente ici — si l'ebook evolue, il faut resynchroniser ce bloc.
 */
(function () {
  'use strict';

  var racine = document.querySelector('[data-essai]');
  if (!racine) return;
  var sortie = racine.querySelector('[data-essai-resultat]');
  if (!sortie) return;

  var NIVEAUX = {
    debutant: {
      split: 'Tout le corps : des mouvements simples à chaque séance',
      freq: '2 à 3 séances par semaine',
      volume: '2 à 3 séries par exercice',
      rest: '60 à 90 secondes entre les séries',
      zones: ['jambes', 'poitrine', 'dos'],
    },
    intermediaire: {
      split: 'Haut du corps / Bas du corps',
      freq: '3 à 5 séances par semaine',
      volume: '3 à 4 séries par exercice',
      rest: '60 à 120 secondes entre les séries',
      zones: ['poitrine', 'dos', 'epaules'],
    },
    avance: {
      split: 'Poussée / Tirage / Jambes',
      freq: '4 à 6 séances par semaine',
      volume: '3 à 5 séries par exercice',
      rest: '60 à 90 s sur les petits exercices, 2 à 3 min sur les plus lourds',
      zones: ['poitrine', 'epaules', 'triceps'],
    },
  };

  var OBJECTIFS = {
    perte: {
      reps: '8 à 15 répétitions',
      calories: 'environ 15 à 20 % de moins que ta dépense estimée',
      macros: { glucides: 40, proteines: 35, lipides: 25 },
    },
    masse: {
      reps: '6 à 12 répétitions',
      calories: 'environ 10 à 15 % de plus que ta dépense estimée',
      macros: { glucides: 50, proteines: 25, lipides: 25 },
    },
    forme: {
      reps: '8 à 15 répétitions',
      calories: 'proche de ta dépense quotidienne estimée',
      macros: { glucides: 45, proteines: 30, lipides: 25 },
    },
  };

  // Le lieu determine le materiel annonce, repris de la colonne "materiel"
  // de FEATURED_EXERCISES dans l ebook.
  var LIEUX = {
    salle: { materiel: "barre, rack, machines et haltères" },
    maison: { materiel: "haltères ou kettlebell, banc facultatif" },
  };


  var lu = function (nom) {
    var input = racine.querySelector('input[name="' + nom + '"]:checked');
    return input ? input.value : null;
  };

  var ligne = function (label, valeur) {
    return '<div class="ta-essai__ligne"><dt>' + label + '</dt><dd>' + valeur + '</dd></div>';
  };

  var composer = function () {
    var niveau = NIVEAUX[lu('niveau')];
    var objectif = OBJECTIFS[lu('objectif')];
    var lieu = LIEUX[lu('lieu')];
    if (!niveau || !objectif || !lieu) return;

    var m = objectif.macros;

    sortie.innerHTML =
      '<p class="ta-essai__split"><span class="ta-essai__label">Tes séances</span>' + niveau.split + '</p>' +
      '<dl class="ta-essai__lignes">' +
        ligne('Fréquence', niveau.freq) +
        ligne('Volume', niveau.volume) +
        ligne('Répétitions', objectif.reps) +
        ligne('Repos', niveau.rest) +
        ligne('Matériel', lieu.materiel) +
        ligne('Calories', objectif.calories) +
        ligne('Répartition', m.glucides + ' % glucides · ' + m.proteines + ' % protéines · ' + m.lipides + ' % lipides') +
      '</dl>';
  };

  racine.addEventListener('change', function (event) {
    if (event.target.matches('input[type="radio"]')) composer();
  });

  composer();
})();

/**
 * Section achat : le bouton reste inactif tant que le consentement numerique
 * n'est pas donne. Pour un contenu livre immediatement, cet accord expres doit
 * etre recueilli separement — une phrase dans les CGV ne suffit pas.
 * Le lien reste un vrai lien : sans JavaScript il fonctionne, et le
 * consentement est de toute facon redemande dans le tunnel Shopify.
 */
(function () {
  'use strict';

  // Plusieurs blocs d'achat peuvent coexister (page de paiement, fiche
  // produit) : on traite chaque paire case + bouton independamment.
  var blocs = [].slice.call(document.querySelectorAll('[data-achat-cta]'));
  if (!blocs.length) return;

  blocs.forEach(function (cta) {
    var portee = cta.closest('.ta-achat__infos, .ta-paiement__action') || document;
    var consent = portee.querySelector('[data-achat-consent]');
    var aide = portee.querySelector('[data-achat-aide]');
    if (!consent) return;

    // Le lien est retire du DOM tant que la case n est pas cochee.
    // `pointer-events: none` ne bloque QUE la souris : au clavier, Tab + Entree
    // partait au panier sans que le consentement ait ete donne.
    var LIEN = cta.getAttribute('href');

    var majuscule = function () {
      var ok = consent.checked;
      cta.classList.toggle('is-disabled', !ok);
      cta.setAttribute('aria-disabled', String(!ok));
      if (ok) {
        cta.setAttribute('href', LIEN);
        cta.removeAttribute('tabindex');
      } else {
        cta.removeAttribute('href');
        cta.setAttribute('tabindex', '-1');
      }
      if (aide) aide.hidden = ok;
    };

    consent.addEventListener('change', majuscule);
    majuscule();
  });
})();

/**
 * C-08 — Le bouton du menu mobile.
 * main.js bascule la classe sur le body, mais ne met pas a jour aria-expanded :
 * un lecteur d ecran ne sait pas si le menu est ouvert. On observe donc la
 * classe plutot que de dupliquer la logique d ouverture.
 */
(function () {
  'use strict';

  var bouton = document.querySelector('.header-toggle');
  var entete = document.querySelector('#header');
  if (!bouton || !entete || !('MutationObserver' in window)) return;

  var refleter = function () {
    var ouvert = entete.classList.contains('header-show');
    bouton.setAttribute('aria-expanded', String(ouvert));
    bouton.setAttribute('aria-label', ouvert ? 'Fermer le menu' : 'Ouvrir le menu');
  };

  new MutationObserver(refleter).observe(entete, { attributes: true, attributeFilter: ['class'] });
  refleter();
})();

/**
 * Bandeau d annonce : transparent tant qu on est sur le hero, opaque ensuite.
 * Sans ce basculement, du texte blanc sur un voile leger deviendrait illisible
 * des que le bandeau passe au-dessus des sections claires.
 */
(function () {
  'use strict';

  var bandeau = document.querySelector('.ta-announcement');
  if (!bandeau) return;

  var majuscule = function () {
    bandeau.classList.toggle('est-transparent', window.scrollY < 60);
  };

  window.addEventListener('scroll', majuscule, { passive: true });
  window.addEventListener('resize', majuscule);
  majuscule();
})();

/**
 * Page unique : l'ancre cliquee restait dans la barre d'adresse. Un simple
 * rafraichissement renvoyait alors le visiteur au milieu de la page, la ou il
 * avait clique la derniere fois — typiquement la FAQ. On laisse l'ancre faire
 * son travail (le defilement), puis on la retire de l'URL. Les liens partages
 * du type /#faq continuent de fonctionner a l'ouverture, et history.replaceState
 * ne touche ni au defilement en cours ni au bouton Precedent.
 */
(function () {
  'use strict';

  if (!window.history || !history.replaceState) return;

  var nettoyer = function () {
    if (!location.hash) return;
    history.replaceState(null, '', location.pathname + location.search);
  };

  // main.js repositionne la page 100 ms apres le chargement : on passe apres.
  if (location.hash) {
    window.addEventListener('load', function () {
      setTimeout(nettoyer, 800);
    });
  }

  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!lien) return;

    var href = lien.getAttribute('href') || '';
    var interne = href.charAt(0) === '#' || href.indexOf('/#') === 0;
    // #top est gere par le bouton « revenir en haut », qui n'ecrit pas d'ancre.
    if (!interne || href === '#top') return;

    setTimeout(nettoyer, 800);
  });
})();
